import React from 'react';
import type { IRootStore } from './root-store';
import { RootStore } from './root-store';
import { ProjectStore } from './project-store';
import { bearerTokenProvider } from '@yakoffice/yakoffice-firebase';
import { ToolStore } from './tool-store';
import { UserStore } from './user-store';
import { ApiRequest } from '../apiGateway/ApiRequest';
import { PortalApiGateway } from '../apiGateway/PortalApiGateway';
import { UsersStore } from './users-store';

export const rootStore = RootStore.create(
  {
    toolStore: ToolStore.create(),
    projectStore: ProjectStore.create(),
    usersStore: UsersStore.create({ apiGateway: PortalApiGateway.create({ apiRequest: ApiRequest.create() }) }),
    userStore: UserStore.create({ apiGateway: PortalApiGateway.create({ apiRequest: ApiRequest.create() }) })
  },
  {
    bearerTokenProvider: bearerTokenProvider
  });

const RootStoreContext = React.createContext<IRootStore>(rootStore);

export const RootStoreProvider = RootStoreContext.Provider;

export default RootStoreContext;
